import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { dashboardData } from '../../slice/dashboardSlice';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone'
import Swal from 'sweetalert2'

const Dashboard = () => {
    const dispatch = useDispatch();
    const { dashboardInfo } = useSelector(state => state.dashboard);

    const [filter, setFilter] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    useEffect(() => {
        dispatch(dashboardData({}))
    }, [dispatch])

    const handleFilterChange = (event) => {
        const value = event.target.value
        setFilter(value)

        if (!value || value === 'custom') return

        const start = moment.tz(userTimeZone).startOf(value).utc().toISOString()
        const end = moment.tz(userTimeZone).endOf(value).utc().toISOString()

        dispatch(
            dashboardData({
                period: value,
                startDate: start,
                endDate: end,
            })
        )
    }

    const handleCustomDateChange = () => {
        if (!startDate || !endDate || moment(startDate).isAfter(endDate)) {
            Swal.fire({
                title: 'Invalid Dates',
                text: 'Please select valid start and end dates.',
                icon: 'error',
                confirmButtonText: 'OK'
            })
            return
        }

        dispatch(
            dashboardData({
                period: 'custom',
                startDate: moment.tz(startDate, userTimeZone).startOf('day').utc().toISOString(),
                endDate: moment.tz(endDate, userTimeZone).endOf('day').utc().toISOString(),
            })
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="page-title-box">
                        <h4 className="page-title">Dashboard</h4>
                    </div>
                </div>
                <div className="col-6 text-end mt-2">
                    <div className="page-title-right d-flex justify-content-end gap-2">
                        <select
                            className="form-select w-auto"
                            value={filter}
                            onChange={handleFilterChange}
                        >
                            <option value="">Select</option>
                            <option value="day">Day</option>
                            <option value="week">Week</option>
                            <option value="month">Month</option>
                            <option value="year">Year</option>
                            <option value="custom">Custom</option>
                        </select>

                        {filter === 'custom' && (
                            <>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                <button
                                    className="btn btn-primary"
                                    onClick={handleCustomDateChange}
                                >
                                    Apply
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className="row">
                <Link to={'/parents'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-account-multiple widget-icon" style={{ color: '#4a81d4' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Parents">Total Parents</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_parents || 0}</h3>
                        </div>
                    </div>
                </Link>

                <Link to={'/tutors'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-school widget-icon" style={{ color: '#1abc9c' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Tutors">Total Tutors</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_tutors || 0}</h3>
                        </div>
                    </div>
                </Link>

                <Link to={'/bookings'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-calendar-check widget-icon" style={{ color: '#f7b84b' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Bookings">Total Bookings</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_bookings || 0}</h3>
                        </div>
                    </div>
                </Link>
            </div>

            <div className="row">
                <Link to={'/badges'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-medal widget-icon" style={{ color: '#f672a7' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Badges">Total Badges</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_badges || 0}</h3>
                        </div>
                    </div>
                </Link>

                <Link to={'/coupons'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-ticket-percent widget-icon" style={{ color: '#4fc6e1' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Coupon Codes">Total Coupons</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_coupon_codes || 0}</h3>
                        </div>
                    </div>
                </Link>

                <Link to={'/reported-bookings'} className="col-xl-4 col-md-4">
                    <div className="card widget-flat">
                        <div className="card-body">
                            <div className="float-end">
                                <i className="mdi mdi-alert-circle widget-icon" style={{ color: '#f1556c' }}></i>
                            </div>
                            <h5 className="text-muted font-weight-normal mt-0" title="Total Reported Bookings">Reported Bookings</h5>
                            <h3 className="mt-3 mb-3">{dashboardInfo?.total_reported_bookings || 0}</h3>
                        </div>
                    </div>
                </Link>
            </div>
        </>
    )
}

export default Dashboard;